import React from "react";
import { TimelineEventSource } from "../../widgets/rolls/RydTimelineHeader";
import { RydProject } from "../../../model/project";
import { useSetWorkspaceBookmarks } from "../../../stores/WorkspaceStore";
import { RydFloatingPanel } from "../../widgets/RydFloatingPanel";
import { RydBookmark, RydBookmarkScope } from "../../../model/bookmark";
import './ContextMenuCommons.css';
import { TrackColor } from "../../../render/trackColor";
import { useSetLoopPlaybackSetup } from "../../../stores/PlaybackConfStore";


function makeBookmark(
    position: number,
    color: TrackColor.Color = TrackColor.getRandomColor(),
    scope: RydBookmarkScope = 'global'
): RydBookmark {
    return {
        position,
        scope: scope,
        label: '',
        color,
        note: '',
    };
}

export function RydTimelineContextMenu({
    target,
    project,
    offset,
    closeCB
}: {
    target: TimelineEventSource,
    project: RydProject,
    zoomFactor: number,
    offset: number,
    closeCB: () => void
}) {

    const setWorkspaceBookmarks = useSetWorkspaceBookmarks();
    const setLoopPlaybackSetup = useSetLoopPlaybackSetup();

    const addBookmark = () => {
        const newBookmark: RydBookmark = makeBookmark(target.timelinePosition);
        project.bookmarks.push(newBookmark);
        setWorkspaceBookmarks([...project.bookmarks]);
        closeCB();
    };

    const setRegionToLoop = () => {
        if (!target.selection) return;
        const color = TrackColor.getRandomColor();
        setLoopPlaybackSetup({
            isLooping: true,
            start: makeBookmark(target.selection.start, color, 'loop'),
            end: makeBookmark(target.selection.end, color, 'loop')
        });
        closeCB();
    }

    return (<RydFloatingPanel
        referenceElement={target.target}
        offsetX={target.normalizedClickPosition - offset}
        offsetY={-20}
    >
        <ul className="ryd-context-menu">
            <li onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                addBookmark();
            }} >
                Add bookmark
            </li>
            {target.selection && (
                <li onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setRegionToLoop();
                }} >
                    Loop region
                </li>
            )}
        </ul>
    </RydFloatingPanel>);
}